/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 04/08/2025
 * @update 04/08/2025
 * @file src/components/W06/W06F2510
 */

import { Column } from "devextreme-react/data-grid";
import {
    Col, Collapse,
    DatePicker,
    Dropdown,
    NumberInput,
    Row,
    Typography
} from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/user-actions";
import * as W06F2510Actions from "../../../actions/w06/w06F2510/w06F2510-actions";
import Config from "../../../config";
import GridActionBar from "../../common/action-bar/grid-action-bar";
import ButtonExport from '../../common/button/button-export';
import GridContainer from "../../common/grid-container/grid-container";
import Link from "../../common/link/link";

const FormID = 'W06F2510';

const W06F2510 = (props) => {
    const [iPermission, setIPermission] = useState(null);
    const [openFilter, setOpenFilter] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [cboPeriodLoading, setCboPeriodLoading] = useState(false);
    const [dataCboPeriodFrom, setDataCboPeriodFrom] = useState([]);
    const [dataCboPeriodTo, setDataCboPeriodTo] = useState([]);
    const [search, setSearch] = useState('');
    const [dataMaster, setDataMaster] = useState({
        DateFrom: null,
        DateTo: null,
        PeriodFrom: '',
        PeriodTo: '',
    });
    const [dataGrid, setDataGrid] = useState([]);

    const exportRef = useRef(null);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadGrid();
        loadCboPeriod();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (iPer) => {
            setIPermission(iPer)
        });
    };

    const getDynamicParams = (data = {}) => {
        const { DateFrom = null, DateTo = null, PeriodFrom = '', PeriodTo = '' } = dataMaster;
        const { DataTypeID = '' } = data || {};
        const objParam = {
            DataTypeID,
            StrSearch: search,
            PeriodFrom,
            PeriodTo,
            DateFrom,
            DateTo,
            PoID: '',
        };
        if (!Config.isEmpty(data)) {
            const arrKeys = Object.keys(data);
            for (let i = 0; i < arrKeys.length; i++) {
                objParam[arrKeys[i]] = data?.[arrKeys[i]];
            }
        }
        return objParam;
    };

    const loadGrid = (text = search) => {
        const params = getDynamicParams({ DataTypeID: 'LoadForm', StrSearch: text });
        setFormLoading(true);
        props.W06F2510Actions.loadGrid(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data || []);
            }
        });
    };

    const loadCboPeriod = () => {
        const params = getDynamicParams({ DataTypeID: 'Period' });
        setCboPeriodLoading(true);
        props.W06F2510Actions.loadCombo(params, (error, data) => {
            setCboPeriodLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboPeriodFrom(data?.[0] || []);
                setDataCboPeriodTo(data?.[1] || []);
            }
        });
    };

    const handleRedirect = (mode, dataRow = {}) => {
        const { POID = '' } = dataRow || {};
        browserHistory.push({
            pathname: Config.getRootPath() + 'W06F2520',
            state: {
                mode,
                POID,
                ...dataRow
            }
        });
    };

    const onEdit = (e) => {
        const { POID: PoID = '' } = e?.data || {};
        const params = getDynamicParams({ DataTypeID: 'CheckEdit', PoID });
        setFormLoading(true);
        props.W06F2510Actions.checkEdit(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleRedirect('edit', e?.data);
                } else if (data?.Message) {
                    Config.popupCore.show('INFO', data.Message);
                }
            }
        });
    };

    const onDelete = (e) => {
        Config.popupCore.show('YES_NO', `${Config.lang('Ban_co_chac_chan_muon_xoa_du_lieu_nay')}`, () => {
            const { POID: PoID = '' } = e?.data || {};
            const params = getDynamicParams({ DataTypeID: 'Delete', PoID });
            props.W06F2510Actions.onDeleteRow(params, (error, data) => {
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return false;
                } else if (data) {
                    if (data?.Status === 0) {
                        Config.notify.show('success', Config.lang('Du_lieu_da_xoa_thanh_cong'), 2000);
                        loadGrid();
                    } else if (data?.Message) {
                        Config.popupCore.show('INFO', data.Message);
                    }
                }
            })
        })
    };

    const renderAction = (e) => {
        return (
            <GridActionBar
                isPer={iPermission}
                tooltipEdit={Config.lang("Sua")}
                onEditAction={() => {
                    onEdit(e)
                }}
                tooltipDelete={Config.lang("Xoa")}
                onDeleteAction={() => {
                    onDelete(e)
                }}
            />
        );
    };

    const renderVoucherNum = (e) => {
        const { POID = '' } = e?.data || {};
        const getData = {
            pathname: Config.getRootPath() + 'W06F2520',
            state: {
                mode: 'view',
                POID,
                ...e?.data || {}
            }
        };
        return <Link getData={() => getData}>{e?.value || ''}</Link>
    };

    const renderNumberFormat = (e) => {
        if (!e) return false;
        return <NumberInput
            nonStyle
            readOnly
            disabledNegative
            maxDigit={28}
            decimalDigit={8}
            thousandSeparator={','}
            inputStyle={{ textAlign: 'right' }}
            value={e?.value}
        />
    };

    const btnCRM = [
        {
            buttonName: Config.lang("Xuat_du_lieu"),
            buttonType: 'button',
            icon: 'fas fa-file-excel text-green',
            align: 'right',
            disabled: false,
            onClick: () => {
                if (exportRef.current.getWrappedInstance().onClick) {
                    exportRef.current.getWrappedInstance().onClick("0");
                }
            }
        },
        {
            buttonName: Config.lang("Loc"),
            buttonType: 'button',
            icon: 'fas fa-filter text-yellow',
            align: 'right',
            disabled: false,
            onClick: () => setOpenFilter(!openFilter)
        }];

    const onSearch = (text) => {
        setSearch(text);
        loadGrid(text);
    };

    const renderGrid = useMemo(() => {
        return (
            <GridContainer
                dataSource={dataGrid}
                onAddNew={() => handleRedirect('add')}
                isPer={iPermission}
                buttonCRM={btnCRM}
                loading={formLoading}
                typePaging={'normal'}
                pagerFullScreen
                itemPerPage={20}
                listPerPage={[20, 40, 60, 80]}
                valueSearch={search}
                onSearch={onSearch} >
                <Column
                    fixed
                    allowSorting={false}
                    cellRender={renderAction}
                    caption={Config.lang('Hanh_dong')}
                    alignment={'center'}
                    width={100}
                />
                <Column
                    dataField={'VoucherNo'}
                    caption={Config.lang("So_don_hang")}
                    cellRender={(e) => renderVoucherNum(e)}
                />
                <Column
                    dataField={'VoucherDate'}
                    alignment={'center'}
                    dataType={'date'}
                    width={150}
                    format={'dd/MM/yyyy'}
                    caption={Config.lang("Ngay_tao")}
                />
                <Column
                    width={200}
                    dataField={'IdentificationID'}
                    caption={Config.lang('MST/CCCD/SoDD')}
                />
                <Column
                    width={200}
                    dataField={'ObjectID'}
                    caption={Config.lang('Khach_hang')}
                />
                <Column
                    width={280}
                    dataField={'AddressCus'}
                    caption={Config.lang('Dia_chi')}
                />
                <Column
                    width={210}
                    dataField={'BankAccountName'}
                    caption={Config.lang('Ten_thu_huong')}
                />
                <Column
                    width={210}
                    dataField={'BankAccountNo'}
                    caption={Config.lang('So_tai_khoan')}
                />
                <Column
                    width={210}
                    dataField={'BankID'}
                    caption={Config.lang('Ngan_hang')}
                />
                <Column
                    width={210}
                    dataField={'DivisionID'}
                    caption={Config.lang('Diem_ban_hang')}
                />
                <Column
                    width={210}
                    dataField={'EmployeeID'}
                    caption={Config.lang('Nhan_vien')}
                />
                <Column
                    width={160}
                    dataField={'SatusPO'}
                    caption={Config.lang('Trang_thai')}
                />
                <Column
                    width={200}
                    dataField={'StatusPayment'}
                    caption={Config.lang('Trang_thai_thanh_toan')}
                />
                <Column
                    width={150}
                    dataType={'number'}
                    alignment={'right'}
                    dataField={'TotalOAmount'}
                    caption={Config.lang('Tong_tien(NT)')}
                    cellRender={renderNumberFormat}
                />
                <Column
                    width={150}
                    dataType={'number'}
                    alignment={'right'}
                    dataField={'TotalCAmount'}
                    caption={Config.lang('Tong_tien(QD)')}
                    cellRender={renderNumberFormat}
                />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, openFilter, formLoading]);

    const paramExport = [
        { "id": "UserID", "type": "VarChar", "value": Config.profile.UserID },
        { "id": "Language", "type": "VarChar", "value": Config.language || '84' },
        { "id": "DivisionID", "type": "VarChar", "value": Config.profile.DivisionID },
        { "id": "StrSearch", "type": "NVarChar", "value": search },
        { "id": "ReportTypeID", "type": "VarChar", "value": FormID },
        { "id": "DataType", "type": "VarChar", "value": 'REPORT' },
        { "id": "DateFrom", "type": "DATETIME", "value": dataMaster?.DateFrom },
        { "id": "DateTo", "type": "DATETIME", "value": dataMaster?.DateTo },
        { "id": "PeriodFrom", "type": "NVarChar", "value": dataMaster?.PeriodFrom },
        { "id": "PeriodTo", "type": "NVarChar", "value": dataMaster?.PeriodTo },
    ];

    const onChange = (keyName, e) => {
        if (!e || !keyName) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        setDataMaster({ ...dataMaster, [keyName]: value });
    };

    if (!iPermission) return null;
    return (
        <div className={'page-container'}>
            <ButtonExport
                className={'hide'}
                ref={ref => exportRef.current = ref}
                reportTypeID={FormID}
                onlyShowPopup
                param={paramExport}
            />
            <Row>
                <Col xs={12}><Typography color={"info"} type={"h4"}>{Config.lang("Danh_sach_don_hang_mua")}</Typography></Col>
                <Col xs={openFilter ? 12 : 0} sx={{ display: { xs: openFilter ? 'block' : 'none' } }}>
                    <Collapse open={openFilter}>
                        <Row>
                            <Col xs={6}>
                                <DatePicker
                                    clearAble
                                    viewType={'outlined'}
                                    displayFormat={"DD/MM/YYYY"}
                                    label={Config.lang('Tu_ngay')}
                                    max={dataMaster?.DateTo}
                                    value={dataMaster?.DateFrom}
                                    onChange={e => onChange('DateFrom', e)}
                                />
                            </Col>
                            <Col xs={6}>
                                <DatePicker
                                    clearAble
                                    viewType={'outlined'}
                                    displayFormat={"DD/MM/YYYY"}
                                    label={Config.lang('Den_ngay')}
                                    min={dataMaster?.DateFrom}
                                    value={dataMaster?.DateTo}
                                    onChange={e => onChange('DateTo', e)}
                                />
                            </Col>
                            <Col xs={6}>
                                <Dropdown
                                    clearAble
                                    viewType={'outlined'}
                                    valueExpr={'PeriodFrom'}
                                    displayExpr={'PeriodFrom'}
                                    label={Config.lang('Tu_ky')}
                                    loading={cboPeriodLoading}
                                    value={dataMaster?.PeriodFrom}
                                    dataSource={dataCboPeriodFrom}
                                    onChange={e => onChange('PeriodFrom', e)}
                                />
                            </Col>
                            <Col xs={6}>
                                <Dropdown
                                    clearAble
                                    viewType={'outlined'}
                                    valueExpr={'PeriodTo'}
                                    displayExpr={'PeriodTo'}
                                    label={Config.lang('Den_ky')}
                                    loading={cboPeriodLoading}
                                    value={dataMaster?.PeriodTo}
                                    dataSource={dataCboPeriodTo}
                                    onChange={e => onChange('PeriodTo', e)}
                                />
                            </Col>
                        </Row>
                    </Collapse>
                </Col>
                <Col xs={12}>{renderGrid}</Col>
            </Row>
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W06F2510Actions: bindActionCreators(W06F2510Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W06F2510);


